import { getAllMdxFilePaths } from '@hashnode/file-parsing'

export function getAllFilesForVersion(versionFolderPath: string) {
	const mdxFilePathsInVersionFolder = getAllMdxFilePaths(versionFolderPath, versionFolderPath, true)
	return {
		mdxFilePathsInVersionFolder,
	}
}
